module.exports = __webpack_public_path__ + "img/img_inner_stripe.1b197286.png";